<template>
  <div class="modal-window large split active" id="print-contract">
    <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <form @submit.prevent="handleSubmit">
        <div class="grid-x split">
          <div class="cell large-6 flex-column">
            <div class="modal-window-header gray">
              <div class="modal-window-heading">
                <h3 class="icon-heading small">
                  <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg></span>
                  <span class="icon-heading-title">
                    <span class="title">Skriv ut {{ printType }}</span>
                  </span>
                </h3>
              </div>

              <fieldset v-if="printType === 'kontrakt'">
                <div class="grid-x grid-padding-x">
                  <TheIntegerInput v-model="maxChars" containerClassName="cell medium-12" label="Begrense tegn?" :symbol="'tegn'" name="maxChars" v-validate="'max:10|integer'"/>
                </div>
              </fieldset>
            </div>

            <div class="modal-window-body">
              <fieldset>
                <div class="grid-x grid-padding-x" :style="{ opacity: pdfSource ? 1 : 0.3 }">
                  <TheTextInput v-model.trim="emailData.from_name" :disabled="!pdfSource" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Avsender'" :placeholder="'Avsender navn…'" name="email_from_name" required v-validate="nameRule"/>
                  <TheEmailInput v-model.trim="emailData.from_mail" :disabled="!pdfSource" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Avsender e-post'" :placeholder="'Avsender e-post…'" name="email_from_mail" required v-validate="mailRule"/>

                  <TheSwitchInput v-model="emailData.send_bcc" containerClassName="cell" :disabled="!pdfSource" :small="true" labelTrue="Send kopi til avsender" labelFalse="Send kopi til avsender" :trueValue="true" :falseValue="false"/>

                  <TheTextInput v-model.trim="emailData.to_name" :disabled="!pdfSource" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Mottaker'" :placeholder="'Mottaker navn…'" name="email_to_name" required v-validate="nameRule"/>
                  <TheEmailInput v-model.trim="emailData.to_mail" :disabled="!pdfSource" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Mottaker e-post'" :placeholder="'Mottaker e-post…'" name="email_to_mail" required v-validate="mailRule"/>

                  <TheTextInput v-model.trim="emailData.subject" :disabled="!pdfSource" containerClassName="cell medium-12" :label="'Emne'" :placeholder="'Emne…'" name="email_subject" required v-validate="subjectRule"/>
                  <TheTextArea v-model="emailData.content" :disabled="!pdfSource" containerClassName="cell medium-12" :label="'Tekst'" :placeholder="'E-post tekst…'" name="email_content"  :rows="3" required v-validate="contentRule"/>
                </div>
              </fieldset>
            </div>

            <div class="modal-window-footer">
              <div class="grid-x">
                <div class="cell align-right">
                  <a v-if="!$store.getters.isFormProcessing" href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
                  <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>

                  <template v-if="pdfSource">
                    <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="emailButtonClick()" class="button primary submit large">Send til kunde</a>
                    <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading">Sender til kunde...<span class="loader-spinner"></span></a>
                    <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large" disabled>Send til kunde</a>
                  </template>
                  <template v-else>
                    <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="submitButtonClick()" class="button primary submit large">Opprett PDF</a>
                    <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading">Oppretter PDF...<span class="loader-spinner"></span></a>
                    <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large" disabled>Opprett PDF</a>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div class="cell large-6 flex-column">
            <div class="modal-window-body no-padding">
              <div class="iframe-container pdf">
                <iframe v-if="pdfSource" id="pdfFrame" name="pdfFrame" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" :src="pdfSource + '#view=FitH&toolbar=1'"></iframe>
                <TheEmptyList v-if="!pdfSource && !$store.getters.isFormProcessing" :title="'Opprett ' + printType" :message="'Trykk på Oprett PDF for å se forhåndsvisning og skrive ut ' + printType" :large="false" :icon="'button-glyph-contract'"/>
                <TheLoader :active="!pdfSource && $store.getters.isFormProcessing"/>
              </div>
            </div>
          </div>
        </div>

        <a v-if="!pdfSource" href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
          <span>Lukk</span>
          <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
        </a>
      </form>
    </overlay-scrollbars>
  </div>
</template>

<script>
import KundeService from '@/services/KundeService'

export default {
  name: 'KundeKontraktCreateModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    kunde: {
      type: Object,
      required: true
    },
    kontrakt: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      maxChars: '',
      printAndSendEmail: false,
      printType: 'kontrakt',
      emailData: {},
      pdfSource: false
    }
  },
  created () {
    this.setFormLoading(false)

    if (this.kontrakt.Kontrakttype === 'K') {
      this.printType = 'kvittering'
    } else {
      this.printType = 'kontrakt'
    }

    // Set default values for the email
    let tempData = {}

    if (this._.has(this.kontrakt, 'mottaker.Email')) {
      tempData.from_mail = this.kontrakt.mottaker.Email
      tempData.from_name = this._.has(this.kontrakt, 'mottaker.full_name') ? this.kontrakt.mottaker.full_name : ''
    } else {
      tempData.from_mail = this.$store.getters.getUser.Email || ''
      tempData.from_name = this.$store.getters.getUser.full_name || ''
    }

    tempData.to_mail = this.kunde.Email
    tempData.to_name = this.kunde.full_name
    tempData.subject = ''
    tempData.content = ''

    tempData.send_bcc = localStorage.sendBccKontraktPdf === 'true' || localStorage.sendBccKontraktPdf === true

    this.emailData = Object.assign({}, tempData)

    this.setEmailData(this.printType)
  },
  mounted () {
    window.jQuery('.modal-window-body').attr('tabindex', -1).css({outline: 'none'}).focus()
  },
  computed: {
    nameRule: function () {
      return this.pdfSource ? 'required|max:100' : ''
    },
    mailRule: function () {
      return this.pdfSource ? 'required|email' : ''
    },
    subjectRule: function () {
      return this.pdfSource ? 'required|max:50' : ''
    },
    contentRule: function () {
      return this.pdfSource ? 'required' : ''
    }
  },
  watch: {
    printType: function (newVal) {
      if (newVal === 'kvittering') {
        this.maxChars = ''
        this.pdfSource = null
        this.setEmailData(newVal)
      } else if (newVal) {
        this.pdfSource = null
        this.setEmailData(newVal)
      }
    }
  },
  methods: {
    setEmailData: function (t) {
      if (t === 'kontrakt') {
        this.emailData.subject = 'Blomqvist Kontrakt #' + this.kontrakt.Kontraktnr
        this.emailData.content = `Kjære kunde

Takk for at du benytter Blomqvist.

Vedlagt finner du kontraktsforslag og vilkår. Vi anbefaler at disse leses nøye.

Kontrakten kan godkjennes ved å besvare denne e-posten med følgende tekst:
Vedlagte kontrakt og kontraktsvilkår aksepteres.

Ta kontakt dersom du har noen spørsmål.

Med vennlig hilsen
BLOMQVIST
` + (this.emailData.from_name ? this.emailData.from_name : 'Kontraktsansvarlig') + `


Dear client

Thank you for using Blomqvist.

Attached you will find the contract proposal and our terms for selling at our auctions.

The contract can be approved by answering this email with the following text:
Attached contract and terms are approved.

Please contact us if there are any questions.

Kind regards
BLOMQVIST
` + (this.emailData.from_name ? this.emailData.from_name : 'Kontraktsansvarlig')
      } else {
        this.emailData.subject = 'Blomqvist Kvittering #' + this.kontrakt.Kontraktnr
        this.emailData.content = `Kjære kunde

Takk for at du ønsker å benytte Blomqvist.

Vedlagt finner du kvittering for innleverte objekt/objekter. En av våre eksperter vil følge deg opp.

Har du spørsmål kan du kontakt oss på kontakt@blomqvist.no


Vennlig hilsen
` + (this.emailData.from_name ? this.emailData.from_name : 'Kontraktsansvarlig') + `



Dear client

Please find your receipt attached to this email.

Thank you for using Blomqvist.


Best regards
` + (this.emailData.from_name ? this.emailData.from_name : 'Kontraktsansvarlig')
      }
    },
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.$emit('close')
      }
    },
    submitButtonClick: function () {
      this.printAndSendEmail = false

      this.handleSubmit()
    },
    emailButtonClick: function () {
      this.printAndSendEmail = true

      this.handleSubmit()
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      var vm = this

      this.setFormProcessing(true)

      if (this.emailData.content) {
        this.emailData.content = this.emailData.content.trim()
      }

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            // Artsafe
            if (this.kontrakt.Avdelingsid === 3) {
              let post = {
                email: this.printAndSendEmail ? this.emailData : null
              }

              KundeService.makeKundeArtsafePdf(this.kunde.Kundenr, this.kontrakt.Kontraktnr, post)
                .then((response) => {
                  let url = process.env.VUE_APP_AVANTI_API_URL + response.data

                  this.pdfSource = url

                  if (this.printAndSendEmail) {
                    // Save last choice of BCC in localstorage
                    localStorage.sendBccKontraktPdf = this.emailData.send_bcc

                    this.$helpers.showSuccessAlert('Kvittering har blitt sendt til kunde')
                    this.$store.dispatch('kontrakthistory/setNeedReload')

                    setTimeout(function () {
                      vm.$emit('close')
                    }, 2500)
                  }
                })
                .catch((error) => {
                  console.log('Error')
                  console.log(error)
                  if (this.printAndSendEmail) {
                    this.$helpers.showErrorAlert('Feil', 'Kunne ikke sende PDF til kunde')
                  } else {
                    this.$helpers.showErrorAlert('Feil', 'Kunne ikke opprette PDF')
                  }
                })
                .then(() => {
                  this.setFormProcessing(false)
                })
            } else if (this.printType === 'kontrakt') {
              let post = {
                chars: this.maxChars,
                email: this.printAndSendEmail ? this.emailData : null
              }

              KundeService.makeKundeKontraktPdf(this.kunde.Kundenr, this.kontrakt.Kontraktnr, post)
                .then((response) => {
                  let url = process.env.VUE_APP_AVANTI_API_URL + response.data

                  this.pdfSource = url

                  if (this.printAndSendEmail) {
                    // Save last choice of BCC in localstorage
                    localStorage.sendBccKontraktPdf = this.emailData.send_bcc

                    this.$helpers.showSuccessAlert('Kontrakten har blitt sendt til kunde')
                    this.$store.dispatch('kontrakthistory/setNeedReload')

                    setTimeout(function () {
                      vm.$emit('close')
                    }, 2500)
                  }
                })
                .catch((error) => {
                  console.log('Error')
                  console.log(error)
                  if (this.printAndSendEmail) {
                    this.$helpers.showErrorAlert('Feil', 'Kunne ikke sende PDF til kunde')
                  } else {
                    this.$helpers.showErrorAlert('Feil', 'Kunne ikke opprette PDF')
                  }
                })
                .then(() => {
                  this.setFormProcessing(false)
                })
            } else {
              let post = {
                email: this.printAndSendEmail ? this.emailData : null
              }

              KundeService.makeKundeKvitteringPdf(this.kunde.Kundenr, this.kontrakt.Kontraktnr, post)
                .then((response) => {
                  let url = process.env.VUE_APP_AVANTI_API_URL + response.data

                  this.pdfSource = url

                  if (this.printAndSendEmail) {
                    // Save last choice of BCC in localstorage
                    localStorage.sendBccKontraktPdf = this.emailData.send_bcc

                    this.$helpers.showSuccessAlert('Kvittering har blitt sendt til kunde')
                    this.$store.dispatch('kontrakthistory/setNeedReload')

                    setTimeout(function () {
                      vm.$emit('close')
                    }, 2500)
                  }
                })
                .catch((error) => {
                  console.log('Error')
                  console.log(error)
                  if (this.printAndSendEmail) {
                    this.$helpers.showErrorAlert('Feil', 'Kunne ikke sende PDF til kunde')
                  } else {
                    this.$helpers.showErrorAlert('Feil', 'Kunne ikke opprette PDF')
                  }
                })
                .then(() => {
                  this.setFormProcessing(false)
                })
            }
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktPrintModal.vue